import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaWhatsapp, FaEnvelope, FaBolt, FaClock, FaCheckCircle } from 'react-icons/fa';

const NewCallToAction = () => {
  const handleContactClick = (type) => {
    switch (type) {
      case 'phone':
        window.open('tel:+97444170859', '_self');
        break;
      case 'email':
        window.open('mailto:abrajaldhafna2014@gmail.com', '_self');
        break;
      case 'whatsapp':
        window.open('https://wa.me/97455994434', '_blank');
        break;
      default:
        break;
    }
  };

  // Design Tokens
  const BRAND_BLUE = "#3b82f6";
  const DARK_BLUE = "#1e3a8a";
  const GOLD = "#fbbf24";

  return (
    <section style={styles.ctaSection}>
      <div style={styles.container}>
        <div style={styles.ctaContent}>
          
          {/* --- Header Section --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 style={styles.ctaTitle}>
              Ready to <span style={{ color: GOLD }}>Get Started?</span>
            </h2>
            <p style={styles.ctaSubtitle}>
              Contact us today for immediate manpower mobilization. 
              Our team is ready to serve your construction needs in Qatar.
            </p>
          </motion.div>

          {/* --- Contact Buttons --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            style={styles.ctaButtons}
          >
            <motion.button
              style={{ ...styles.btn, ...styles.btnSecondary }}
              onClick={() => handleContactClick('phone')}
              whileHover={{ scale: 1.05, boxShadow: '0 10px 20px rgba(0,0,0,0.2)' }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPhone /> Call Now
            </motion.button>

            <motion.button
              style={{ ...styles.btn, ...styles.btnWhatsapp }}
              onClick={() => handleContactClick('whatsapp')}
              whileHover={{ scale: 1.05, backgroundColor: '#22c55e' }}
              whileTap={{ scale: 0.95 }}
            >
              <FaWhatsapp /> WhatsApp
            </motion.button>

            <motion.button
              style={{ ...styles.btn, ...styles.btnOutline }}
              onClick={() => handleContactClick('email')}
              whileHover={{ scale: 1.05, backgroundColor: 'rgba(255,255,255,0.1)' }}
              whileTap={{ scale: 0.95 }}
            >
              <FaEnvelope /> Email Quote
            </motion.button>
          </motion.div>

          {/* --- Trust Info Grid --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            style={styles.infoGrid}
          >
            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FaBolt color={GOLD} /></div>
              <h4 style={styles.infoTitle}>Immediate Response</h4>
              <p style={styles.infoText}>Get a response within 30 minutes</p>
            </div>
            
            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FaClock color={GOLD} /></div>
              <h4 style={styles.infoTitle}>24/7 Availability</h4>
              <p style={styles.infoText}>Round-the-clock support</p>
            </div>
            
            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FaCheckCircle color={GOLD} /></div>
              <h4 style={styles.infoTitle}>Certified Workers</h4>
              <p style={styles.infoText}>Experienced and vetted tradesmen</p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

// --- Styles Object ---
const styles = {
  ctaSection: {
    padding: '100px 20px',
    background: 'linear-gradient(135deg, #313d63ff 0%, #0c1633ff 100%)',
    position: 'relative',
    overflow: 'hidden',
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  ctaContent: {
    textAlign: 'center',
    color: '#ffffff',
  },
  ctaTitle: {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: '900',
    marginBottom: '20px',
    lineHeight: '1.1',
  },
  ctaSubtitle: {
    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
    maxWidth: '700px',
    margin: '0 auto 40px',
    opacity: '0.9',
    lineHeight: '1.6',
  },
  ctaButtons: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    flexWrap: 'wrap', // Responsive wrapping for mobile
    marginBottom: '60px',
  },
  btn: {
    padding: '16px 32px',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    border: 'none',
    transition: 'all 0.3s ease',
  },
  btnSecondary: {
    backgroundColor: '#fbbf24', // Gold
    color: '#061026ff',
  },
  btnWhatsapp: {
    backgroundColor: '#25d366', // WhatsApp Green
    color: '#ffffff',
  },
  btnOutline: {
    backgroundColor: 'transparent',
    color: '#ffffff',
    border: '2px solid rgba(255,255,255,0.3)',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', // Responsive grid
    gap: '30px',
    marginTop: '20px',
  },
  infoItem: {
    padding: '30px',
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '20px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  infoIcon: {
    fontSize: '28px',
    marginBottom: '15px',
  },
  infoTitle: {
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '8px',
  },
  infoText: {
    color: '#ffffff',
    fontSize: '14px',
    opacity: '0.7',
  },
};

export default NewCallToAction;